import { render, staticRenderFns } from "./SocialMediaButtons.vue?vue&type=template&id=11344063&scoped=true"
import script from "./SocialMediaButtons.vue?vue&type=script&lang=js"
export * from "./SocialMediaButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaButtons.vue?vue&type=style&index=0&id=11344063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11344063",
  null
  
)

export default component.exports